var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmartphone = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.25 1.5C6.55964 1.5 6 2.05964 6 2.75V21.25C6 21.9404 6.55964 22.5 7.25 22.5H16.75C17.4404 22.5 18 21.9404 18 21.25V2.75C18 2.05964 17.4404 1.5 16.75 1.5H7.25ZM4.5 2.75C4.5 1.23122 5.73122 0 7.25 0L16.75 0C18.2688 0 19.5 1.23122 19.5 2.75V21.25C19.5 22.7688 18.2688 24 16.75 24H7.25C5.73122 24 4.5 22.7688 4.5 21.25V2.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 19.5C13.5 20.3284 12.8284 21 12 21C11.1716 21 10.5 20.3284 10.5 19.5C10.5 18.6716 11.1716 18 12 18C12.8284 18 13.5 18.6716 13.5 19.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 3.75C9 3.33579 9.33579 3 9.75 3H14.25C14.6642 3 15 3.33579 15 3.75C15 4.16421 14.6642 4.5 14.25 4.5H9.75C9.33579 4.5 9 4.16421 9 3.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smartphone.05e7d587a5b31d4dbccbc2b5901d23aa.svg";